
import Vue from 'vue'
import TheHeader from '@/components/TheHeader.vue'

export default Vue.extend({
  name: 'App',

  components: { TheHeader },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },

    shouldShowHeader() {
      return !!this.$route.name && ![
        'login',
        'password-forgot',
        'password-reset',
        'password-set'
      ].includes(this.$route.name)
    }
  },

  mounted() {
    // this.initZendeskWidgets()
  },

  methods: {
    initZendeskWidgets() {
      const zendeskWidgets: HTMLScriptElement = document.createElement("script")
      zendeskWidgets.setAttribute("id", "ze-snippet")
      zendeskWidgets.src = "https://static.zdassets.com/ekr/snippet.js?key=22a051db-2548-4785-8ac5-a04ab867ace1"
      document.head.appendChild(zendeskWidgets)
    },

    afterLeave() {
      this.$setChecked(false)
    }
  }
})
